import useOrderIdStore from "@store/order/useOrderIdStore";
import { useMutation } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackHeader from "@components/header/BackHeader";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import TossBillingButton from "@pages/subscribe/TossBillingButton";
import TossPaymentButton from "@components/button/TossPaymentButton";
import BasicButton from "@components/button/BasicButton";
import useUserInfoStore from "@store/useUserInfoStore";

const Container = styled.div(({ theme }) => ({
  padding: "2rem",
  backgroundColor: theme.color.white,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  // minHeight: "calc(100vh - 5.6rem)",
  position: "relative",
  minHeight: "100dvh",
  // justifyContent: "center",
}));

const ContentWrapper = styled.div({
  maxWidth: "48rem",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // marginTop: "28.2rem",
});

const Title = styled.div(({ theme }) => ({
  fontSize: "2.4rem",
  // marginBottom: "4.8rem",
  textAlign: "center",
}));

const ButtonWrapper = styled.div({
  position: "absolute",
  padding: "0 2rem",
  width: "100%",
  bottom: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
});

const ReviewSuccess = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { userInfo } = useUserInfoStore();

  const navigate = useNavigate();

  return (
    <Container>
      <ContentWrapper>
        <Flex vertical align="center" gap={"4rem"}>
          <Image
            src={theme.image.check_circle.default}
            width="6rem"
            height="6rem"
          />
          <Title>{t("리뷰가 작성되었습니다")}</Title>
        </Flex>

        <ButtonWrapper>
          <BasicButton
            title="작성한 리뷰 보러가기"
            onClick={() => navigate(`/review/${userInfo?.id}`)}
            width="100%"
            height="5.2rem"
            outlined
          />

          <BasicButton
            title="메인 페이지로 이동"
            onClick={() => navigate("/")}
            width="100%"
            height="5.2rem"
          />
        </ButtonWrapper>
      </ContentWrapper>
    </Container>
  );
};

export default ReviewSuccess;
